/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency_codes';
import '../common/currency';
import '../common/time';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "sub2": {
        "nested": {
          "data": {
            "nested": {
              "Duration": {
                "fields": {
                  "unit": {
                    "type": "squareup.sub2.data.Duration.DurationUnit",
                    "id": 1,
                    "rule": "optional"
                  },
                  "count": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "DurationUnit": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "DAY": 1,
                      "MONTH": 2,
                      "YEAR": 3
                    }
                  }
                }
              },
              "SaasMoney": {
                "fields": {
                  "currencyCode": {
                    "type": "squareup.common.CurrencyCode",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FixedPricing": {
                "fields": {
                  "cost": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UsageUnitType": {
                "values": {
                  "INVALID": 0,
                  "EMPLOYEE": 1,
                  "RETAIL_DEVICE": 2,
                  "CUSTOMER": 3,
                  "APPOINTMENTS_EMPLOYEE": 4,
                  "RESTAURANTS_LOCATION": 5,
                  "RESTAURANTS_ADDITIONAL_DEVICE": 6,
                  "RETAIL_LOCATION": 7,
                  "RETAIL_ADDITIONAL_DEVICE": 8,
                  "EMPLOYEE_MANAGEMENT_LOCATION": 9,
                  "SPOS_DEVICE_SETTINGS_DEVICE": 10,
                  "REACHABLE_CONTACTS": 11,
                  "LOYALTY_LOCATIONS": 12,
                  "LOYALTY_TRANSACTIONS": 13,
                  "LOYALTY_TRANSACTIONS_TIER": 14,
                  "PAYROLL_EMPLOYEE": 15,
                  "PAYROLL_W2_EMPLOYER": 16,
                  "MARKETING_SMS_MESSAGES": 17,
                  "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_1": 18,
                  "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2": 19,
                  "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3": 20,
                  "KDS_DEVICE": 21,
                  "APPOINTMENTS_LOCATIONS": 22,
                  "RESTAURANTS_MOBILE_LOCATION": 23,
                  "SHIFTS_TEAM_MEMBER": 24,
                  "ECOM_SITES": 25,
                  "ECOM_ACCOUNT": 26,
                  "MARKETING_MMS_MESSAGES": 27,
                  "COMMS_TEAM_MEMBER": 28,
                  "MESSAGES_LOCATION": 29,
                  "HR_TOOLKIT_EMPLOYEE": 30,
                  "HR_MANAGER_EMPLOYEE": 31,
                  "STAFF_TEAM_MEMBER": 32,
                  "HR_MANAGER_TEAM_MEMBER": 33,
                  "PAYROLL_MAILED_TAX_FORM": 34,
                  "STAFF_LOCATION": 35,
                  "FNB_KIOSK_DEVICE": 36,
                  "COMBOS_LOCATION": 37,
                  "FRANCHISE_LOCATION": 38,
                  "RESTAURANTS_MOBILE_DEVICE": 39,
                  "LOYALTY_PAYG_USAGE": 40,
                  "LOYALTY_PAYG_LOCATION": 41,
                  "BILLABLE_LOCATION": 42
                }
              },
              "TieredPricing": {
                "fields": {
                  "unitType": {
                    "type": "squareup.sub2.data.UsageUnitType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pricingTier": {
                    "type": "squareup.sub2.data.TieredPricing.Tier",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "currentTier": {
                    "type": "squareup.sub2.data.TieredPricing.Tier",
                    "id": 3,
                    "rule": "optional"
                  },
                  "calculation": {
                    "type": "squareup.sub2.data.TieredPricing.Calculation",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Tier": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "minUsageCount": {
                        "type": "uint32",
                        "id": 3,
                        "rule": "optional"
                      },
                      "maxUsageCount": {
                        "type": "uint32",
                        "id": 4,
                        "rule": "optional"
                      },
                      "cost": {
                        "type": "squareup.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "baseCost": {
                        "type": "squareup.common.Money",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "Calculation": {
                    "values": {
                      "FIXED": 0,
                      "BULK": 1,
                      "USAGE": 2
                    }
                  }
                }
              },
              "BucketPricing": {
                "fields": {
                  "cost": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitType": {
                    "type": "squareup.sub2.data.UsageUnitType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "bucketSize": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": 1
                    }
                  },
                  "minUnits": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "baseCost": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "UsageBucket": {
                "fields": {
                  "cost": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "unitType": {
                    "type": "squareup.sub2.data.UsageUnitType",
                    "id": 2,
                    "rule": "optional"
                  },
                  "size": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": 1
                    }
                  },
                  "minUnits": {
                    "type": "uint32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "label": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "freeUnitCount": {
                    "type": "uint32",
                    "id": 6,
                    "rule": "optional"
                  },
                  "fractionalCost": {
                    "type": "squareup.sub2.data.SaasMoney",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              },
              "MultiBucketPricing": {
                "fields": {
                  "buckets": {
                    "type": "squareup.sub2.data.UsageBucket",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "baseCost": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "RetailPricing": {
                "fields": {
                  "retailDeviceCost": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "excessEmployeeCost": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "excessCustomerBucketCost": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Pricing": {
                "fields": {
                  "label": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "startAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 7,
                    "rule": "optional"
                  },
                  "expireAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 8,
                    "rule": "optional"
                  },
                  "customPricing": {
                    "type": "bool",
                    "id": 9,
                    "rule": "optional"
                  },
                  "fixedPricing": {
                    "type": "squareup.sub2.data.FixedPricing",
                    "id": 1
                  },
                  "bucketPricing": {
                    "type": "squareup.sub2.data.BucketPricing",
                    "id": 2
                  },
                  "retailPricing": {
                    "type": "squareup.sub2.data.RetailPricing",
                    "id": 3
                  },
                  "tieredPricing": {
                    "type": "squareup.sub2.data.TieredPricing",
                    "id": 4
                  },
                  "multiBucketPricing": {
                    "type": "squareup.sub2.data.MultiBucketPricing",
                    "id": 6
                  }
                },
                "nested": {
                  "pricing_types": {
                    "oneof": [
                      "fixedPricing",
                      "bucketPricing",
                      "retailPricing",
                      "tieredPricing",
                      "multiBucketPricing"
                    ]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Duration && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Duration?.nested?.DurationUnit && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.SaasMoney && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.FixedPricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.UsageUnitType && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.TieredPricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.TieredPricing?.nested?.Tier && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.TieredPricing?.nested?.Calculation && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.BucketPricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.UsageBucket && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.MultiBucketPricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.RetailPricing && !$root.nested?.squareup?.nested?.sub2?.nested?.data?.nested?.Pricing) {
	$root.addJSON(jsonData);
}

/**
 * Duration represents duration in days/months/years.
 *
 * SOURCE Duration @ squareup/sub2/data.proto at 108:1
 */
export const Duration = $root.lookupType('squareup.sub2.data.Duration');
fixType(Duration, {
  unit: { required: true },
  count: { required: true },
});
Builder.createAndAttachToType(Duration);
/**
 * SOURCE DurationUnit @ squareup/sub2/data.proto at 109:3
 */
Duration.DurationUnit = $root.lookupEnum('squareup.sub2.data.Duration.DurationUnit').values;
/**
 * A money type with support for fractional amounts, e.g. $0.075.
 *
 * SOURCE SaasMoney @ squareup/sub2/data.proto at 676:1
 */
export const SaasMoney = $root.lookupType('squareup.sub2.data.SaasMoney');
fixType(SaasMoney, {
  currencyCode: { required: true },
  amount: { required: true },
});
Builder.createAndAttachToType(SaasMoney);
/**
 * FixedPricing represents flat fee pricing.
 *
 * SOURCE FixedPricing @ squareup/sub2/data.proto at 686:1
 */
export const FixedPricing = $root.lookupType('squareup.sub2.data.FixedPricing');
fixType(FixedPricing, {
  cost: { required: true },
});
Builder.createAndAttachToType(FixedPricing);
/**
 * The type of unit for usage/pricing. For example, employee, register device, etc.
 *
 * SOURCE UsageUnitType @ squareup/sub2/data.proto at 691:1
 */
export const UsageUnitType = $root.lookupEnum('squareup.sub2.data.UsageUnitType').values;
/**
 * TieredPricing defines various tiers that have pricing levels. Example:
 *   Tier 1: $50 for up to 25 employees
 *   Tier 2 $75 for up to 100 employees
 *
 * SOURCE TieredPricing @ squareup/sub2/data.proto at 747:1
 */
export const TieredPricing = $root.lookupType('squareup.sub2.data.TieredPricing');
fixType(TieredPricing, {
  unitType: { required: true },
  pricingTier: { required: true },
});
Builder.createAndAttachToType(TieredPricing);
/**
 * SOURCE Tier @ squareup/sub2/data.proto at 751:3
 */
TieredPricing.Tier = $root.lookupType('squareup.sub2.data.TieredPricing.Tier');
fixType(TieredPricing.Tier, {
  minUsageCount: { required: true },
  cost: { required: true },
});
Builder.createAndAttachToType(TieredPricing.Tier);
/**
 * Assuming that we have a product X and the tiers are (based on unit counts):
 * 1. 0-50
 * 2. >= 51
 *
 * SOURCE Calculation @ squareup/sub2/data.proto at 785:3
 */
TieredPricing.Calculation = $root.lookupEnum('squareup.sub2.data.TieredPricing.Calculation').values;
/**
 * BucketPricing defines pricing per number of units. Examples:
 *   $5 per 1 employee
 *   $10 per 3 register device
 *   $15 per 500 customers
 * There may also be a non-zero "base" cost, such as:
 *   $10 plus $2 per location
 *
 * SOURCE BucketPricing @ squareup/sub2/data.proto at 823:1
 */
export const BucketPricing = $root.lookupType('squareup.sub2.data.BucketPricing');
fixType(BucketPricing, {
  cost: { required: true },
  unitType: { required: true },
});
Builder.createAndAttachToType(BucketPricing);
/**
 * UsageBucket represent the bucket parameters for a single usage unit type
 *
 * SOURCE UsageBucket @ squareup/sub2/data.proto at 841:1
 */
export const UsageBucket = $root.lookupType('squareup.sub2.data.UsageBucket');
fixType(UsageBucket, {
  unitType: { required: true },
});
Builder.createAndAttachToType(UsageBucket);
/**
 * MultiBucketPricing defines pricing per number of units across multiple bucket types.
 * Examples:
 *   $60 per 1 location plus $40 per register
 *   $15 per 500 customers plus $20 per employee
 * There may also be a non-zero "base" cost, such as:
 *   $10 plus $2 per location plus $10 per employee
 *
 * SOURCE MultiBucketPricing @ squareup/sub2/data.proto at 874:1
 */
export const MultiBucketPricing = $root.lookupType('squareup.sub2.data.MultiBucketPricing');
fixType(MultiBucketPricing, {
  buckets: { required: true },
});
Builder.createAndAttachToType(MultiBucketPricing);
/**
 * The RetailPricing message is deprecated .
 *
 * SOURCE RetailPricing @ squareup/sub2/data.proto at 883:1
 */
export const RetailPricing = $root.lookupType('squareup.sub2.data.RetailPricing');
fixType(RetailPricing, {
  retailDeviceCost: { required: true },
  excessEmployeeCost: { required: true },
  excessCustomerBucketCost: { required: true },
});
Builder.createAndAttachToType(RetailPricing);
/**
 * Pricing defines a collection of different types of pricing schemes offered in Subscriptions.
 *
 * SOURCE Pricing @ squareup/sub2/data.proto at 895:1
 */
export const Pricing = $root.lookupType('squareup.sub2.data.Pricing');
fixType(Pricing);
Builder.createAndAttachToType(Pricing);
